var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "row" }, [
        _c("h3", [_vm._v("Tak for besøget")]),
        _c("div", { staticClass: "row" }),
        _c("p", [_vm._v("Din MitID session er nu afsluttet.")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }